var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSweeping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6705 23.0918C9.8417 22.2556 9.19482 21.257 8.77051 20.1588",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2847 19.4346C18.2847 19.4346 14.1697 20.4716 11.3377 13.8006C11.1209 13.2893 10.8054 12.8257 10.4094 12.4363C10.0133 12.0469 9.54446 11.7394 9.02953 11.5313C8.51459 11.3232 7.9637 11.2186 7.40832 11.2234C6.85294 11.2283 6.30396 11.3425 5.79274 11.5596C1.80374 13.2176 3.54774 17.1046 3.54774 17.1046C3.54774 17.1046 4.36974 22.0966 6.98174 23.6136C12.0587 23.7716 18.2847 19.4346 18.2847 19.4346Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95679 17.0328L11.3378 14.0408",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67163 1.32559C2.67163 1.32559 3.39863 8.97759 5.79263 11.5596",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8467 15.0366C16.5706 15.0366 16.3467 14.8127 16.3467 14.5366C16.3467 14.2605 16.5706 14.0366 16.8467 14.0366",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8467 15.0366C17.1228 15.0366 17.3467 14.8127 17.3467 14.5366C17.3467 14.2605 17.1228 14.0366 16.8467 14.0366",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3467 10.5366C18.0706 10.5366 17.8467 10.3127 17.8467 10.0366C17.8467 9.76045 18.0706 9.53659 18.3467 9.53659",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3467 10.5366C18.6228 10.5366 18.8467 10.3127 18.8467 10.0366C18.8467 9.76045 18.6228 9.53659 18.3467 9.53659",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7236 13.7866C21.4475 13.7866 21.2236 13.5627 21.2236 13.2866C21.2236 13.0105 21.4475 12.7866 21.7236 12.7866",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7236 13.7866C21.9997 13.7866 22.2236 13.5627 22.2236 13.2866C22.2236 13.0105 21.9997 12.7866 21.7236 12.7866",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.447754 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweeping);
export default __webpack_public_path__ + "static/media/sweeping.95eb0dda26f3df94d22d8cf252ce4876.svg";
export { ForwardRef as ReactComponent };